import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { HeaderInterceptors } from './core/interceptor/header-interceptor.service';
import { LoaderInterceptor } from './core/interceptor/loader.interceptor';
import { ResponseInterceptors } from './core/interceptor/response-interceptor.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { NgxNumberSpinnerModule } from './ngx-number-spinner/ngx-number-spinner.module';
import { PublicComponent } from './layout/public';
import { PrivateComponent } from './layout/private';
import { AuthGuard } from './core/guards/auth.guard';
import { PublicGuard } from './core/guards/public.gaurd';
import { LoaderComponent } from './shared/loader/loader.component';
import { SharedModule } from './shared/shared.module';
import { UserModule } from './user/user.module';
import { HomeModule } from './home/home.module';
import { CartModule } from './cart/cart.module';
import { ProductModule } from './product/product.module';
import { ProfileModule } from './profile/profile.module';
import { TestComponent } from './test/test.component';
import { GraphQLModule } from './graphql.module';
import { OrderModule } from './order/order.module';
import { StaticContentModule } from './static-content/static-content.module';
import {NgcCookieConsentModule, NgcCookieConsentConfig} from 'ngx-cookieconsent';
import { CookieService } from 'ngx-cookie-service';
import { GoogleAnalyticsService } from './shared/services/google-analytics.service';
import { AuthInterceptor } from './core/interceptor/auth.interceptor';
import { PromotionModule } from './promotion/promotion.module';
import { ApolloModule } from 'apollo-angular'
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module, ReCaptchaV3Service } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { RatingModule } from 'ngx-bootstrap/rating';
import { FeedbackModule } from './feedback/feedback.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { StoreDevtoolsModule } from '@ngrx/store-devtools';

const cookieConfig:NgcCookieConsentConfig = {
  cookie: {
    domain: environment.domainName // or 'your.domain.com' // it is mandatory to set a domain, for cookies to work properly (see https://goo.gl/S2Hy2A)
  },
  palette: {
    popup: {
      background: "#2BA292",//"#000000",
      text: "#ffffff"
    },
    button: {
      background: "#FDCC49",//"#f1d600",
      text: "#1F2227", //"#000000",
    }
  },
  theme: 'classic',
  type: 'opt-out',
  content: {
    message: "This website uses cookies to ensure you get the best experience on our website.",
    dismiss: "Got it!",
    deny: "Refuse cookies",
    link: "Learn more",
    href: "https://cookiesandyou.com",
    policy: "Cookie Policy"
  }
};
@NgModule({
  declarations: [
    AppComponent,
    PublicComponent,
    PrivateComponent,
    LoaderComponent,
    TestComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ToastrModule,
    NgSelectModule,
    FormsModule,
    RecaptchaV3Module,
    ReactiveFormsModule,
    HttpClientModule,
    UserModule,
    PromotionModule,
    SharedModule,
    HomeModule,
    FeedbackModule,
    CartModule,
    OrderModule,
    StaticContentModule,
    ProductModule,
    ProfileModule,
    BrowserAnimationsModule,
    BsDropdownModule.forRoot(),
    ToastrModule.forRoot({ preventDuplicates: true }),
    SlickCarouselModule,
    CarouselModule.forRoot(),
    AccordionModule.forRoot(),
    NgxNumberSpinnerModule,
    GraphQLModule,
    NgcCookieConsentModule.forRoot(cookieConfig),
    ApolloModule,
    RatingModule.forRoot(),
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({maxAge: 25})
  ],
  providers: [
    AuthGuard,
    PublicGuard,
    CookieService,
    GoogleAnalyticsService,
    ReCaptchaV3Service,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptors, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptors, multi: true },
    // { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptchasiteKey,
    },
    

    
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }
